export const postEmployee = async (formData) => {
    try {
        const resp = await fetch(`${process.env.REACT_APP_API}/employer/form`, {
            method: "POST",
            headers: {
                "Content-type": "application/json",
            },
            body: JSON.stringify(formData),
        });
        return resp.json();
    } catch (error) {
        console.error(error);
    }
};

export const postEmployeeToSmtm = async (formData, companyIdFromSMTM) => {
    let befit_group = getBenefitGroupBySmtm(formData.levelId);

    let area_id_smtm = getAreaByCountry(formData.countryId, formData.areaId);

    let cityId = getCityIdByCountrySmtm(formData.countryId);

    try {
        const body = {
            company_id: companyIdFromSMTM, //El Id de la compañia pero de SMTM (Te paso endpoint)
            country_id: formData.countryId, //Cambiar pais dinamico
            city_id: cityId, //Lo mismo aca con la ciudad
            job_name: formData.jobId, //Realmente es el nombre, no el ID. pero se deja asi por la Lambda
            subArea: formData.subAreaId, //Lo mismo de arriba
            area_id: parseInt(area_id_smtm),
            group: befit_group,
            english_level_id: parseInt(formData.englishLevel),
            seniority_id: parseInt(formData.seniorityLevel),
            qualification_id: parseInt(formData.gradeLevel),
            current_salary: parseInt(formData.salary),
            variable_salary: parseInt(formData.variableSalary),
        };
        const resp = await fetch(
            `https://smtm.co/v1/position_companies?company_id=${companyIdFromSMTM}`,
            {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(body),
            }
        );
        const data = await resp.json();
    } catch (error) {
        console.error(error);
    }
};

const getAreaByCountry = (country, areaMydna) => {
    let area_id_smtm;

    //Chile
    if (country === "1") {
        switch (areaMydna) {
            case 1:
                area_id_smtm = "2";
                break;
            case 2:
                area_id_smtm = "88";
                break;
            case 3:
                area_id_smtm = "3";
                break;
            case 4:
                area_id_smtm = "92";
                break;
            case 5:
                area_id_smtm = "87";
                break;
            case 6:
                area_id_smtm = "5";
                break;
            case 7:
                area_id_smtm = "90";
                break;
            case 8:
                area_id_smtm = "7";
                break;
            case 9:
                area_id_smtm = "1";
                break;
            case 10:
                area_id_smtm = "91";
                break;
            case 11:
                area_id_smtm = "4";
                break;
             case 12:
                area_id_smtm = "89";
                break;
            case 13:
                area_id_smtm = "93";
                break;
            case 14:
                area_id_smtm = "6";
                break;
            case 15:
                area_id_smtm = "1"; 
                break;

            default:
                area_id_smtm = "1";
        }
    }

    //Argentina
    if (country === "2") {
        switch (areaMydna) {
            case 1:
                area_id_smtm = "21";
                break;
            case 2:
                area_id_smtm = "102";
                break;
            case 3:
                area_id_smtm = "22";
                break;
            case 4:
                area_id_smtm = "106";
                break;
            case 5:
                area_id_smtm = "101";
                break;
            case 6:
                area_id_smtm = "24";
                break;
            case 7:
                area_id_smtm = "104";
                break;
            case 8:
                area_id_smtm = "136";
                break;
            case 9:
                area_id_smtm = "20";
                break;
            case 10:
                area_id_smtm = "105";
                break;
            case 11:
                area_id_smtm = "23";
                break;
            case 12: //Educación
                area_id_smtm = "103";
                break;
            case 13: //salud
                area_id_smtm = "107";
                break;
            case 14: 
                area_id_smtm = "20"; //financieros
                break;
            case 15:
                area_id_smtm = "20"; //Financieros
                break;

            default:
                area_id_smtm = "21";
        }
    }

    //Peru
    if (country === "3") {
        switch (areaMydna) {
            case 1:
                area_id_smtm = "15";
                break;
            case 2:
                area_id_smtm = "95";
                break;
            case 3:
                area_id_smtm = "16";
                break;
            case 4:
                area_id_smtm = "99";
                break;
            case 5:
                area_id_smtm = "94";
                break;
            case 6:
                area_id_smtm = "18";
                break;
            case 7:
                area_id_smtm = "97";
                break;
            case 8:
                area_id_smtm = "19";
                break;
            case 9:
                area_id_smtm = "14";
                break;
            case 10:
                area_id_smtm = "98";
                break;
            case 11:
                area_id_smtm = "17";
                break;

            case 12: //Educación
                area_id_smtm = "96";
                break;
            case 13: //salud
                area_id_smtm = "100";
                break;
            case 14: //Seguros, no existe en SMTM
                area_id_smtm = "14"; //Financieros
                break;
            case 15:
                area_id_smtm = "14"; //Financieros
                break;

            default:
                area_id_smtm = "15";
        }
    }

    //Brasil
    if (country === "4") {
        switch (areaMydna) {
            case 1:
                area_id_smtm = "9";
                break;
            case 2:
                area_id_smtm = "130";
                break;
            case 3:
                area_id_smtm = "10";
                break;
            case 4:
                area_id_smtm = "134";
                break;
            case 5:
                area_id_smtm = "129";
                break;
            case 6:
                area_id_smtm = "12";
                break;
            case 7:
                area_id_smtm = "132";
                break;
            case 8:
                area_id_smtm = "13";
                break;
            case 9:
                area_id_smtm = "8";
                break;
            case 10:
                area_id_smtm = "133";
                break;
            case 11:
                area_id_smtm = "11";
                break;

            case 12: //Educación
                area_id_smtm = "65";
                break;
            case 13: //salud
                area_id_smtm = "62";
                break;
            case 14: //Seguros, no existe en SMTM
                area_id_smtm = "8"; //Financiero
                break;
            case 15:
                area_id_smtm = "8"; //Financiero
                break;

            default:
                area_id_smtm = "9";
        }
    }

    //Colombia
    if (country === "5") {
        switch (areaMydna) {
            case 1:
                area_id_smtm = "67";
                break;
            case 2:
                area_id_smtm = "109";
                break;
            case 3:
                area_id_smtm = "68";
                break;
            case 4:
                area_id_smtm = "113";
                break;
            case 5:
                area_id_smtm = "108";
                break;
            case 6:
                area_id_smtm = "70";
                break;
            case 7:
                area_id_smtm = "111";
                break;
            case 8:
                area_id_smtm = "71";
                break;
            case 9:
                area_id_smtm = "66";
                break;
            case 10:
                area_id_smtm = "112";
                break;
            case 11:
                area_id_smtm = "69";
                break;
            case 12: //Educación
                area_id_smtm = "110";
                break;
            case 13: //salud
                area_id_smtm = "114";
                break;
            case 14: //Seguros, no existe en SMTM
                area_id_smtm = "66"; //Financiero
                break;
            case 15:
                area_id_smtm = "66"; //Financiero
                break;

            default:
                area_id_smtm = "67";
        }
    }

    //Mexico
    if (country === "6") {
        switch (areaMydna) {
            case 1:
                area_id_smtm = "74";
                break;
            case 2:
                area_id_smtm = "123";
                break;
            case 3:
                area_id_smtm = "75";
                break;
            case 4:
                area_id_smtm = "127";
                break;
            case 5:
                area_id_smtm = "122";
                break;
            case 6:
                area_id_smtm = "77";
                break;
            case 7:
                area_id_smtm = "125";
                break;
            case 8:
                area_id_smtm = "78";
                break;
            case 9:
                area_id_smtm = "73";
                break;
            case 10:
                area_id_smtm = "126";
                break;
            case 11:
                area_id_smtm = "76";
                break;

            case 12: //Educación
                area_id_smtm = "124";
                break;
            case 13: //salud
                area_id_smtm = "128";
                break;
            case 14: //Seguros, no existe en SMTM
                area_id_smtm = "73"; //Financiero
                break;
            case 15:
                area_id_smtm = "73"; //Financiero
                break;

            default:
                area_id_smtm = "74";
        }
    }

    //Ecuador
    if (country === "7") {
        switch (areaMydna) {
            case 1:
                area_id_smtm = "81";
                break;
            case 2:
                area_id_smtm = "116";
                break;
            case 3:
                area_id_smtm = "82";
                break;
            case 4:
                area_id_smtm = "120";
                break;
            case 5:
                area_id_smtm = "115";
                break;
            case 6:
                area_id_smtm = "84";
                break;
            case 7:
                area_id_smtm = "118";
                break;
            case 8:
                area_id_smtm = "85";
                break;
            case 9:
                area_id_smtm = "80";
                break;
            case 10:
                area_id_smtm = "119";
                break;
            case 11:
                area_id_smtm = "83";
                break;

            case 12: //Educación
                area_id_smtm = "117";
                break;
            case 13: //salud
                area_id_smtm = "121";
                break;
            case 14: //Seguros, no existe en SMTM
                area_id_smtm = "80"; //Financiero
                break;
            case 15:
                area_id_smtm = "80"; //Financiero
                break;

            default:
                area_id_smtm = "81";
        }
    }

    return area_id_smtm;
};

const getBenefitGroupBySmtm = (grupo) => {
    let befit_group;
    switch (grupo) {
        case 1:
            befit_group = "Operario";
            break;
        case 2:
            befit_group = "Operario";
            break;
        case 3:
            befit_group = "Analista";
            break;
        case 4:
            befit_group = "Analista";
            break;
        case 5:
            befit_group = "Especialista";
            break;
        case 6:
            befit_group = "Jefe";
            break;
        case 7:
            befit_group = "SubGerente";
            break;
        case 8:
            befit_group = "Gerente";
            break;
        case 9:
            befit_group = "Director";
            break;
        case 10:
            befit_group = "CEO";
            break;

        default:
            befit_group = "Analista";
            break;
    }

    return befit_group;
};
const getCityIdByCountrySmtm = (country) => {
    let cityId;

    switch (country) {
        case "1":
            cityId = "1";
            break;

        case "2":
            cityId = "2";
            break;

        case "3":
            cityId = "3";
            break;

        case "4":
            cityId = "4";
            break;

        case "5":
            cityId = "16";
            break;

        case "6":
            cityId = "22";
            break;

        case "7":
            cityId = "23";
            break;

        default:
            cityId = "1";
            break;
    }

    return cityId;
};
export const getEmployeesByCompany = async (companyId) => {
    try {
        const resp = await fetch(
            `${process.env.REACT_APP_API}/employer/company/${companyId}`,
            {
                method: "GET",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return resp.json();
    } catch (error) {
        console.error(error);
    }
};

export const getEmployee = async (employeeId) => {
    try {
        const resp = await fetch(
            `${process.env.REACT_APP_API}/employer/${employeeId}`,
            {
                method: "GET",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return resp.json();
    } catch (error) {
        console.error(error);
    }
};

export const putEmployee = async (data, employeeId) => {
    try {
        const resp = await fetch(
            `${process.env.REACT_APP_API}/employer/${employeeId}`,
            {
                method: "PUT",
                headers: {
                    "Content-type": "application/json",
                },
                body: JSON.stringify(data),
            }
        );
        const respSmtm = await fetch(
            `https://smtm.co/v1/update_position_from_mydna`,
            {
                method: "PUT",
                headers: {
                    "Content-type": "application/json",
                },
                body: JSON.stringify(data),
            }
        );
        return resp.json();
    } catch (error) {
        console.error(error);
    }
};

export const deleteEmployee = async (employeeId) => {
    try {
        const resp = await fetch(
            `${process.env.REACT_APP_API}/employer/${employeeId}`,
            {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return resp.json();
    } catch (error) {
        console.error(error);
    }
};

export const postAssetsEmployee = async (data) => {
    try {
        const resp = await fetch(
            `${process.env.REACT_APP_API}/assetsuploader/employee`,
            {
                method: "POST",
                headers: {
                    "Content-type": "application/json",
                },
                body: JSON.stringify(data),
            }
        );
        return resp.json();
    } catch (error) {
        console.error(error);
    }
};
export const getAssetsEmployee = async (employeeId) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_API}/assetsuploader/employee/${employeeId}`,
            {
                method: "GET",
                headers: {
                    "Content-type": "application/json",
                },
            }
        );
        return response.json();
    } catch (error) {
        console.error(error);
    }
};
export const delAssetsEmployee = async (assetsId) => {
    try {
        const resp = await fetch(
            `${process.env.REACT_APP_API}/assetsuploader/employee/${assetsId}`,
            {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return resp.json();
    } catch (error) {
        console.error(error);
    }
};

export const getAllPhotoUrls = async (employeeId) => {
    // datos que deseas enviar en la solicitud POST
    const data = {};

    // opciones para la solicitud POST
    const options = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    };

    // URL del endpoint al que deseas enviar la solicitud POST
    const url = `https://api.develop.mydnadigital.com/v1/assetsuploader/employeesPhotoUrls/${JSON.parse(localStorage.getItem('user')).id}`;

    // hacer la solicitud POST con fetch()
    const resp = await fetch(url, options)

    return resp.json();
};
